const WelcomeSection = ({ userName, profileImage }) => {
    return (
        <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
                <h2 className="text-white fs-4 fw-bold mb-1">
                    Welcome Back, {userName}!
                </h2>
                <p className="text-secondary mb-0 small">
                    Track your investments, earnings, and impact in real-time
                </p>
            </div>
            <img
                src={profileImage || "/placeholder.svg"}
                alt={userName}
                className="rounded-circle"
                style={{ width: "40px", height: "40px" }}
            />
        </div>
    );
};

export default WelcomeSection;
